var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".region-select .info-control[data-v-4201fb71]{height:1rem;line-height:1rem;display:flex;justify-content:space-between;background-color:#fff}.region-select .arr-item[data-v-4201fb71]{padding-right:.8rem}.region-select .arr-item[data-v-4201fb71]:after{right:0}.region-select .card-item[data-v-4201fb71]{position:relative}.region-select .card-item .icon[data-v-4201fb71]{position:absolute;background:url(" + escape(require("../../static/img/choice-success.png")) + ") no-repeat;background-size:100% 100%;right:.8rem;top:.25rem;width:.6rem;height:.6rem}.region-panel[data-v-4201fb71]{position:absolute;top:0;left:0;right:0;bottom:0;transition:all .6s;background-color:#eff3f6;overflow:hidden;z-index:9999;overflow-y:auto;height:26.666667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4201fb71","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TypeSelect.vue
// module id = 438
// module chunks = 0